module.exports = __webpack_public_path__ + "img/dr_8.279fa696.png";